export default __webpack_public_path__ + "static/media/ExporterIcon.e768d659.svg";